import(/* webpackMode: "eager" */ "/vercel/path0/components/About.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/Hero.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/Work.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js")